var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "800"
    }
  }, [_c('console-title', [_c('span', [_vm._v("회원등급")])]), _c('console-body', [_c('v-data-table', {
    staticClass: "mt-2 mx-1 elevation-1",
    attrs: {
      "items": _vm.levels,
      "headers": _vm.levelsHeaders,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    }])
  }), _c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "accent"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }